module.exports = __webpack_public_path__ + "static/media/ops_en.48784ee5.png";